export default __webpack_public_path__ + "static/header-educacao-infantil-89877d4636e5e853764c535d0752875e.png";